var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg4Mobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 526,
    viewBox: "0 0 360 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_110540)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.82,
    cy: 407.121,
    rx: 278.82,
    ry: 407.121,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 352.117 121.984)",
    fill: "url(#paint0_linear_447_110540)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_110540",
    x: -330.883,
    y: 0.830078,
    width: 1198.84,
    height: 1236.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    result: "effect1_foregroundBlur_447_110540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_110540",
    x1: 278.82,
    y1: 0,
    x2: 278.82,
    y2: 814.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4Mobile);
export default __webpack_public_path__ + "static/media/bg4-mobile.998b69ed4ccb9bc36931f9b5a2190095.svg";
export { ForwardRef as ReactComponent };